<script setup>
defineProps({
  number: {
    type: [String, Number],
    default: 1,
  },

  title: {
    type: String,
    required: true,
  },

  text: {
    type: String,
    required: true,
  },
});

const { tp } = useTypograf();
</script>

<template>
  <div class="card-process">
    <div class="card-process__number">
      <span class="card-process__font card-process__font--number">
        {{ number }}
      </span>
    </div>

    <div class="card-process__content">
      <h3 class="card-process__title">
        <span class="card-process__font card-process__font--title">
          {{ title }}
        </span>
      </h3>

      <p class="card-process__text">
        <span class="card-process__font card-process__font--text">
          {{ tp(text) }}
        </span>
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-process {
  display: flex;
  gap: em(14);
  border-radius: em(8);
  border: em(2.5) solid $color-main-1;
  padding-block: em(39) em(38);
  padding-inline: em(29) em(46);
  background-color: $color-gray-22;

  @include rtl {
    padding-top: em(30);
    padding-inline-end: em(46);
    padding-bottom: em(38);
    padding-inline-start: em(29);
  }

  @include media-breakpoint-mobile {
    gap: em(10);
    padding-block: em(19) em(30);
    padding-inline: em(18) em(28);
  }

  &__number {
    @include box(em(36));
    background-color: $color-main-30;
    border-radius: em(10);
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-white;
    flex-shrink: 0;

    @include media-breakpoint-mobile {
      @include box(em(26));
      border-radius: em(6);
    }
  }

  &__content {
    padding-top: em(3);
  }

  &__title {
    margin-bottom: em(23);

    @include media-breakpoint-mobile {
      margin-bottom: em(16);
    }
  }

  &__font {
    &--number {
      font-size: em(22);
      font-weight: $font-weight-medium;

      @include media-breakpoint-mobile {
        font-size: em(16);
      }
    }

    &--title {
      font-size: em(22);
      font-weight: $font-weight-semi-bold;
      line-height: em(27, 22);

      @include media-breakpoint-mobile {
        font-size: em(16);
        line-height: em(19, 16);
      }
    }

    &--text {
      font-size: em(22);
      line-height: em(27, 22);
      font-weight: $font-weight-light;

      @include media-breakpoint-mobile {
        font-size: em(16);
        line-height: em(19, 16);
      }
    }
  }
}
</style>
